import Config from "services/config/config";
import callWebService, { callTypes } from "services/utils/networks/network";
import { FOLLOW_UP_LISTING, FOLLOW_DETAILS } from "./type";

export const getFollowUpListing = (leadId, page = 1) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.followUpList.list}?lead_id=${leadId}&page=${page}`
  );
  if (res?.data?.status_code === 403) {
    return null;
  }
  if (res?.data?.response?.status === true) {
    const { data } = res;
    dispatch({
      type: FOLLOW_UP_LISTING,
      payload: data.response.data,
    });
    return true;
  }
};

export const getFollowUpDetail = (followUpId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.followUp.followUpDetails}?id=${followUpId}`
  );
  if (res?.data?.response?.status === true) {
    const { data } = res;
    dispatch({
      type: FOLLOW_DETAILS,
      payload: data.response.data.resultSets,
    });
    return true;
  }
};
